import { makeAutoObservable } from "mobx"
import Loader from "reusable/mobx-helpers/Loader"
import { createStoreContext } from "reusable/mobx-store-utils/storeUtils"
import { MindsetDto } from '@gap/backend/app-services/mindset/models/MindsetDto'
import { apiClient } from "api/trpc/trpc-client"
import ModalState from "reusable/mobx-helpers/ModalState"
import MindsetsDialogStore from "./MindsetsDialogStore"
import { notNull } from "@gap/utils/utils"
import OrgGuardStore from "features/main/main-router/org-guard/OrgGuardStore"

interface MindsetsStoreProps {
   orgGuardStore: OrgGuardStore
}

export default class MindsetsStore {
   sp
   mindsets: MindsetDto.list = []
   loader = new Loader(true)
   modifyMindsetModal = new ModalState({
      onOpen: () => {
         this.mindsetsDialogStore.mindset = {}
      },
      onClose: reason => {
         if (reason === 'succeeded') {
            this.fetch()
         }
      }
   })
   mindsetsDialogStore

   constructor(sp: MindsetsStoreProps) {
      makeAutoObservable(this)
      this.sp = sp
      this.mindsetsDialogStore = new MindsetsDialogStore({ modalState: this.modifyMindsetModal, orgGuardStore: this.sp.orgGuardStore })
   }

   fetch = async () => {
      await this.loader.executeLoading(async () => {
         this.mindsets = await apiClient.mindset.list.query()
      })
   }

   editMindset = (event: React.MouseEvent<HTMLElement>) => {
      const mindsetId = event.currentTarget.getAttribute("data-id")
      if (!mindsetId) return

      const mindset = notNull(this.mindsets.find(({ id }) => id === mindsetId))
      this.modifyMindsetModal.open()
      this.mindsetsDialogStore.mindset = mindset
   }

   deleteMindset = async () => {
      const deleted = await this.mindsetsDialogStore.delete()
      if (deleted) {
         this.mindsets = this.mindsets.filter(mindset => mindset.id !== this.mindsetsDialogStore.mindset.id)
         this.mindsetsDialogStore.mindset = {}
      }
   }
}

export const { Provider: MindsetsStoreProvider, useProvidedStore: useMindsetsStore } = createStoreContext(MindsetsStore)
